import { Button, Popconfirm, PopconfirmProps } from '@arco-design/web-react';
import React from 'react';

export function ButtonDelete({ onOk }: PopconfirmProps) {
  return (
    <Popconfirm title="确定删除?" onOk={onOk}>
      <Button type="secondary" status="danger" size="small">
        删除
      </Button>
    </Popconfirm>
  );
}
